import { Component, OnInit } from "@angular/core";
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from "@angular/forms";
import {
  BarcodeDefinition,
  BarcodeReader,
  CameraDefinition,
} from "../../yard-simulator.model";
import { AppServerAPI, ServiceResponse } from "@sdbn/common";

@Component({
  selector: "app-barcode-reader",
  templateUrl: "./barcode-reader.component.html",
  styleUrls: ["./barcode-reader.component.scss"],
})
export class BarcodeReaderComponent implements OnInit {
  barcodeReaderSelected: BarcodeDefinition;
  barcodeReaders: BarcodeDefinition[];

  scannedNumber: string;

  formGroup = new FormGroup({});

  constructor(
    private service: AppServerAPI
  ) {
    this.formGroup.addControl("scannedNumber", new FormControl("", []));
    this.formGroup.addControl("barcodeSelection", new FormControl("", []));
    this.formGroup.valueChanges.subscribe((formValues) => {
      this.scannedNumber = formValues.scannedNumber;
    });
  }

  ngOnInit() {
    this.service
      .execute<CameraDefinition[]>(
        '/client/admin/yard-simulator/barcode-readers',
        {}
      )
      .subscribe((barcodeReaders) => {
        this.barcodeReaders = barcodeReaders;
      });
  }

  onBarcodeReaderSelection(barcodeReader: BarcodeDefinition) {
    this.barcodeReaderSelected = barcodeReader;
  }

  onButtonTrigger() {
    const barcodeReader = new BarcodeReader({
      identifier: this.barcodeReaderSelected.identifier,
      scannedNumber: this.scannedNumber,
    });

    this.service
      .execute<ServiceResponse>(
        '/client/admin/yard-simulator/barcode',
        barcodeReader
      )
      .subscribe((response) => {
        console.log(response.status, ":\n", response.responseMessages);
      });
  }
}
